import withDialog from 'hoc/withDialog'
import PhoneForm from 'forms/PhoneForm/PhoneForm'
import PhoneSchema from 'schemas/PhoneSchema'

const defaultPhoneValues = {
  number: '',
  type: 'mobile',
  acceptSms: true,
  preferred: true,
}

type AddPhoneDialogProps = {
  open: boolean
  onDismiss: () => void
  onSubmit: () => void
}

const AddPhoneDialog = (props: AddPhoneDialogProps) => (
  <PhoneForm
    onSubmit={props.onSubmit}
    onCancel={props.onDismiss}
    initialValues={defaultPhoneValues}
    schema={PhoneSchema}
  />
)

export default withDialog(AddPhoneDialog)
